<template>
  <BaseNotification>
    <slot />
    <div
      class="global-notification__actions"
      v-if="!loading"
    >
      <a class="cursor-pointer global-notification__action" @click="handleAccept">
        <aha-icon
          class="mr-1 align-top"
          name="check"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        />
        {{ $i18nPresenter.t("Accept") }}
      </a>
      <a class="cursor-pointer ml-7 global-notification__action --secondary" @click="handleDecline">
        <aha-icon
          class="mr-1 align-top"
          name="close"
          width="18"
          height="18"
          viewBox="0 0 24 24"
        />
        {{ $i18nPresenter.t("Decline") }}
      </a>
    </div>
    <aha-spinner class="ml-7 mt-3 sm:mt-0 self-start sm:self-center" variant="white" v-else />
  </BaseNotification>
</template>

<script>
import BaseNotification from './BaseNotification.vue'

export default {
  components: {
    BaseNotification,
  },
  props: {
    handleAccept: {
      type: Function,
      default: () => {},
    },
    handleDecline: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.global-notification {
  &__actions {
    @apply flex self-start mt-3 sm:ml-8 sm:self-center sm:mt-0 font-bold;
  }

  &__action {
    @apply text-base-30 whitespace-nowrap;

    &:hover {
      @apply text-base-0 opacity-100;
    }
  }

  &__action.--secondary {
    @apply opacity-50;
    &:hover {
      @apply opacity-100;
    }
  }
}
</style>
